export default "__VITE_ASSET__Ct9aOAk2__"